function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
var youtubeIdRegex = /(?:https?:\/\/)?(?:(?:www\.)?(?:youtube(?:-nocookie)?|youtube.googleapis)\.com.*(?:v\/|v=|vi=|vi\/|e\/|embed\/|user\/.*\/u\/\d+\/)|youtu\.be\/)([_0-9a-z-]+)/i;
export var getYoutubeVideoId = function getYoutubeVideoId(url) {
  if (!url) {
    return null;
  }
  var matches = url.match(youtubeIdRegex);
  return matches ? matches[1] : null;
};
var YoutubeThumbnailResolution = /*#__PURE__*/function (YoutubeThumbnailResolution) {
  YoutubeThumbnailResolution["MAX"] = "maxresdefault";
  YoutubeThumbnailResolution["DEFAULT"] = "default";
  YoutubeThumbnailResolution["HIGH"] = "hqdefault";
  YoutubeThumbnailResolution["MEDIUM"] = "mqdefault";
  YoutubeThumbnailResolution["STANDARD"] = "sddefault";
  return YoutubeThumbnailResolution;
}(YoutubeThumbnailResolution || {});
var generateYoutubeThumbnail = function generateYoutubeThumbnail(videoId) {
  var quality = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : YoutubeThumbnailResolution.HIGH;
  return "https://img.youtube.com/vi/".concat(videoId, "/").concat(quality, ".jpg");
};
var generateYoutubeEmbededUrl = function generateYoutubeEmbededUrl(videoId) {
  return "https://www.youtube.com/embed/".concat(videoId);
};
export var generateGalleryItems = function generateGalleryItems() {
  var images = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var video = arguments.length > 1 ? arguments[1] : undefined;
  var items = _toConsumableArray(images);
  if (video) {
    var videoId = getYoutubeVideoId(video);
    if (!videoId) {
      return items;
    }
    items.splice(1, 0, {
      id: 'video-1',
      type: 'video',
      video: generateYoutubeEmbededUrl(videoId),
      photoFileName: 'school-video',
      original: generateYoutubeThumbnail(videoId, YoutubeThumbnailResolution.HIGH),
      thumbnail: generateYoutubeThumbnail(videoId, YoutubeThumbnailResolution.HIGH)
    });
  }
  return items;
};